import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { Platform } from 'react-native';
import { View } from 'react-native';

import Text from '../../../../components/common/text';
import NavigationArrow from '../../../../components/common/navigation-arrow';

import KeyValueListView from '../../../../components/common/key-value-list-view';
import AbbreviatedGroup from '../../../../components/common/abbreviated-group';
import TransactionDetailsDescription from './transaction-details-description';

import styles from './transaction-details.styles';

class  TransactionDetails extends Component{

  constructor(props){
    super(props);

    this.state =   {
      modal: false,
      doneVisible: true,
    };

    this.toggleModal = this.toggleModal.bind(this);
  }

  componentWillMount(){
    const {
      row = {},
      headerGroup = [],
      detailsGroups = [],
      labels = {},
      abbreviationRules = {},
      messages
    } =  this.props;
  }

 toggleModal() {
    const { changePage,tradeNumber,valueDate,tradeDate,row } = this.props;
    const adviceItem = {
      tradeNo: row.tradeNumber,
    };

     this.props.transact.getAdvices({
       adviceItem
    });
  }

  render() {
    const {
      modal,
      doneVisible
    } = this.state;

    const { transact, messages } = this.props;

    if (transact.isEmpty) {
      transact.setIsEmpty(false);
      alert('No advices available');
    }

    return (
      <View style={styles.root} testID="expandable-item">
        <View testID="details">
          <AbbreviatedGroup
            data={this.props.row}
            dataDefinitions={this.props.headerGroup}
            abbreviationRules={this.props.abbreviationRules}
            renderTopSeparator={false}
            renderBottomSeparator
          />
          <KeyValueListView
            detailsGroups={this.props.detailsGroups}
            row={this.props.row}
            abbreviationRules={this.props.abbreviationRules}
            renderFirstSeparator={false}
            messages={messages}
          />
        </View>
        <TransactionDetailsDescription description={this.props.row.type} />
          <div style={{'cursor': 'pointer'}} onClick={this.toggleModal}>
            <Text> {this.props.labels.seeAdvice}</Text>
            <span className="arrowClass"><NavigationArrow/></span>
          </div>
      </View>
    );
  }
}

TransactionDetails.propTypes = {
  row: PropTypes.shape({
    type: PropTypes.string,
    tradeNumber: PropTypes.number,
    valueDate: PropTypes.string,
    purchasePrice: PropTypes.number,
    purchasePriceUnit: PropTypes.string,
    netAmount: PropTypes.number,
  }),
  detailsGroups: KeyValueListView.propTypes.detailsGroups,
  labels: PropTypes.shape({
    seeAdvice: PropTypes.string,
  }),
  headerGroup: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string,
    key: PropTypes.string,
    type: PropTypes.string,
  })),
  abbreviationRules: PropTypes.object,
  modal: PropTypes.bool,
  doneVisible: PropTypes.bool,
};

export default TransactionDetails;
